<ng-container>
  <app-student-slip-payment-info
    [amountDue]="itemChoicesComponentInfo.due"
    [balance]="itemChoicesComponentInfo.balance"
    [status]="itemChoicesComponentInfo.status"
    [confirmationPending]="paymentProgress.state === PaymentState.ConfirmingPayment"
    [processingPayment]="paymentProgress.state !== PaymentState.Initialised">
  </app-student-slip-payment-info>

  <div class="paymentContainer" [hidden]="!showForm">
    @if (isHybrid) {
      <div>
        <app-student-slip-item-choices-payment-hybrid
          [slipComponentInfo]="slipComponentInfo"
          [itemChoicesComponentInfo]="itemChoicesComponentInfo"
          [paymentStatus]="paymentProgress.paymentStatus"
          [reservationExpiresOn]="reservationExpiresOn"
          (paymentMethodUpdated)="onPaymentMethodUpdated($event)"
          (paymentStatusChange)="paymentStatusChange.emit($event)"
          (requestReservationRefresh)="requestReservationRefresh.emit()">
        </app-student-slip-item-choices-payment-hybrid>
      </div>
    }
    @if (!isHybrid) {
      <div>
        <app-student-slip-item-choices-payment-web
          [slipComponentInfo]="slipComponentInfo"
          [itemChoicesComponentInfo]="itemChoicesComponentInfo"
          [paymentStatus]="paymentProgress.paymentStatus"
          [reservationExpiresOn]="reservationExpiresOn"
          (paymentStatusChange)="onPaymentStatusChanged($event)"
          (requestReservationRefresh)="requestReservationRefresh.emit()">
        </app-student-slip-item-choices-payment-web>
      </div>
    }
  </div>
  @switch (paymentProgress.state) {
    @case (PaymentState.ProcessingPayment) {
      <span class="processingPayment">
        <div class="contentWrapper">
          <div class="imageSpinnerCont">
            <ion-spinner name="crescent"></ion-spinner>
          </div>
          <div class="textCont">
            <p class="header">Processing payment</p>
            <p class="subHeader">PLEASE WAIT</p>
          </div>
        </div>
      </span>
    }
    @case (PaymentState.ConfirmingPayment) {
      <span class="paymentSuccess" [@slideUpFadeInWithChild]>
        <div class="contentWrapper">
          <div class="imageSpinnerCont">
            <img src="/assets/icon/tick-icon-green.svg" />
          </div>
          <div class="textCont">
            <p class="header">
              {{ paymentProgress.paymentStatus.method === 'google' ? 'Success! Paid with Google' : 'Payment success!' }}
            </p>
            <p class="subHeader" [@delayedSlideUpFadeIn]>
              <ion-spinner name="crescent"></ion-spinner> CONFIRMATION PENDING
            </p>
          </div>
        </div>
      </span>
    }
    @case (PaymentState.PaymentConfirmed) {
      <span class="paymentConfirmed" [@slideUpFadeIn]>
        <div class="contentWrapper">
          <div class="imageSpinnerCont">
            <img src="/assets/icon/tick-icon-green.svg" />
          </div>
          <div class="textCont">
            <p class="header">
              {{ paymentProgress.paymentStatus.method === 'google' ? 'Paid with Google Pay' : 'Payment confirmed!' }}
            </p>
            <p class="subHeader" [@delayedSlideUpFadeIn]>WE'VE EMAILED YOU A RECEIPT</p>
          </div>
        </div>
      </span>
    }
  }
</ng-container>
